import { decamelize } from "humps";
import api from "@/services/api";
const REPEATED_PARAMS = { indexes: null };
const prefixed = api;
const methods = prefixed.getPrefixedMethods("worklist");
export const worklistService = {
    list(params, signal) {
        return methods.get("", { params, signal, paramsSerializer: REPEATED_PARAMS });
    },
    async counts(params, signal) {
        const counts = await methods.get("counts", {
            params,
            signal,
            paramsSerializer: REPEATED_PARAMS,
        });
        return Object.fromEntries(Object.entries(counts).map(([key, value]) => [decamelize(key), value]));
    },
    filterOptions(type) {
        return methods.get("filter-options", type ? { params: { type } } : undefined);
    },
};
